<template>
    <div class="flex p-12 space-y-7 items-center justify-center">
        <div class="absolute md:text-2xl text-base font-semibold text-biru mr-24 md:mr-44 ">{{ $t("message.kosong") }}
        </div>
        <img src="@/assets/icon/empty.svg" class="ml-20 md:ml-20" alt="" />
    </div>
</template>

<script>

</script>